import { useSelector } from 'react-redux';
import FJFake3dAnimation from './FJFake3dAnimation';
import { useDispatch } from 'react-redux';
import FJActionFake3d from '../../../../redux/action/FJActionFake3d';
import useLocalStore from '../../../../hooks/useLocalStore';

const FJFake3dAnimationContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();
    const animationStyle = useSelector(state => state.fake3d.animationStyle);
    const direction = useSelector(state => state.fake3d.direction);
    const intensity = useSelector(state => state.fake3d.intensity);
    const duration = useSelector(state => state.fake3d.duration);
    const returnAnimation = useSelector(state => state.fake3d.returnAnimation);
    const reverse = useSelector(state => state.fake3d.reverse);
    const onAnimationStyleChange = value => {
        dispatch(FJActionFake3d.setAnimationStyleAction(value));
    };

    const onDirectionChange = value => {
        dispatch(FJActionFake3d.setDirectionAction(value));
    };

    const onIntensityChange = (value, isUpdateRender) => {
        dispatch(FJActionFake3d.setIntensityAction(value, isUpdateRender));
    };

    const onDurationChange = (value, isUpdateRender) => {
        dispatch(FJActionFake3d.setDurationAction(value, isUpdateRender));
    };

    const onReturnAnimationChange = value => {
        dispatch(FJActionFake3d.setReturnAnimationAction(value));
    };

    const onReverseChange = value => {
        dispatch(FJActionFake3d.setReverseAction(value));
    };

    return (
        <FJFake3dAnimation
            animationStyle={animationStyle}
            direction={direction}
            intensity={intensity}
            duration={duration}
            returnAnimation={returnAnimation}
            reverse={reverse}
            onAnimationStyleChange={onAnimationStyleChange}
            onDirectionChange={onDirectionChange}
            onIntensityChange={onIntensityChange}
            onDurationChange={onDurationChange}
            onReturnAnimationChange={onReturnAnimationChange}
            onReverseChange={onReverseChange}
        />
    );
};

export default FJFake3dAnimationContainer;
